import { motion } from 'framer-motion'
import { getMedalEmoji, getPositionOrdinal } from '../../lib/utils'

interface PositionIndicatorProps {
  position: number
  totalParticipants: number
  className?: string
}

export function PositionIndicator({
  position,
  totalParticipants,
  className = '',
}: PositionIndicatorProps) {
  const medal = getMedalEmoji(position)
  const isLeading = position === 1

  return (
    <motion.div
      animate={isLeading ? { scale: [1, 1.05, 1] } : {}}
      transition={{ duration: 1, repeat: Infinity }}
      className={`text-center ${className}`}
    >
      <div className="text-sm uppercase text-gray-400 font-quicksand mb-2">
        Position
      </div>

      <div className="flex items-center justify-center gap-3">
        {medal ? (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity }}
            className="text-5xl"
          >
            {medal}
          </motion.div>
        ) : (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-tropical-green to-paradise-blue"
          >
            <div className="text-4xl font-fredoka font-700 text-white">
              {position}
            </div>
          </motion.div>
        )}

        <div>
          <div className="text-4xl font-fredoka font-700 text-tropical-green">
            {getPositionOrdinal(position)}
          </div>
          <div className="text-xs text-gray-400">
            out of {totalParticipants}
          </div>
        </div>
      </div>

      {isLeading && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-3 px-4 py-2 bg-tropical-green text-palm-dark rounded-full text-sm font-fredoka font-600"
        >
          IN THE LEAD!
        </motion.div>
      )}
    </motion.div>
  )
}
